module.exports = __webpack_public_path__ + "img/rating-ico-3.339ec7b4.png";